/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useState} from 'react';
import {BackHandler, Platform, View} from 'react-native';
import RNExitApp from 'react-native-exit-app';
import {formatDateTo} from '../../../common/utils/functions';
import {Validation} from '../../../common/utils/validationInscription';
import {PRIVACY} from '../../../data/constants/alphabet';
import {TitleLabels} from '../../../data/constants/inscription';
import {useForm} from '../../../hooks/Inscription/useForm';
import SecondaryButton from '../../components/Button/SecondaryButton';
import {CheckBoxWithHyperlink} from '../../components/CheckBoxWithHyperlink';
import {Footer} from '../../components/Footer/Footer';
import {Header} from '../../components/Header/HeaderInscription';
import {InputDatePicker} from '../../components/Inputs/InputDatePicker';
import {InputField} from '../../components/Inputs/InputField';
import {InputImage} from '../../components/Inputs/InputImage';
import {InputImageViewer} from '../../components/Inputs/InputImageViewer';
import {InputPhoneNumber} from '../../components/Inputs/InputPhoneNumber';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';
import {Separator} from '../../components/Separator';

export const Form = (props: any) => {
  const {data, listAgence, onCancelForm, onSubmitForm, connectAction} = props;
  const [isSelected, setSelected] = useState(false);
  const [isCheck, setCheck] = useState(false);

  const {handleChange, handleSubmit, values, errors, showErrors, dto} = useForm(
    data,
    Validation,
    handleCancel,
    handleSave,
    listAgence,
  );

  const exit = () => {
    if (Platform.OS == 'ios') {
      RNExitApp.exitApp();
    } else {
      BackHandler.exitApp();
    }
  };

  function privacyIsChecked() {
    setCheck(!isSelected);
  }

  function handleCancel() {
    onCancelForm();
  }

  function handleSave() {
    if (dto.data.dateNaissance instanceof Date) {
      dto.data.dateNaissance = formatDateTo(
        dto.data.dateNaissance,
        'DD/MM/YYYY',
      );
    }
    onSubmitForm(dto.data);
  }

  function dismiss() {
    setCheck(false);
  }

  return (
    <View>
      {/** form inputs */}
      <View>
        <Header />
        <View>
          <Separator />
        </View>
        <View>
          {isCheck && (
            <ConfirmationModal
              title="Confidentialité"
              content={PRIVACY}
              btn1="OK"
              btn2="Annuler"
              handleBtn1={dismiss}
              handleBtn2={exit}
            />
          )}
          <InputImageViewer
            label={TitleLabels.contractant.image}
            required
            value={values.image}
            name="image"
            onChange={handleChange}
            error={errors.image}
            showError={showErrors.image}
          />
          <InputField
            label={TitleLabels.contractant.nom}
            required
            value={values.nom}
            name="nom"
            onChange={handleChange}
            error={errors.nom}
            showError={showErrors.nom}
            maxLength={50}
          />
          <InputField
            label={TitleLabels.contractant.prenom}
            required
            value={values.prenom}
            name="prenom"
            onChange={handleChange}
            error={errors.prenom}
            showError={showErrors.prenom}
            maxLength={50}
          />
          <InputPhoneNumber
            label={TitleLabels.contractant.telephone}
            required
            name="telephone"
            type="telephone"
            value={values.telephone}
            onChange={handleChange}
            error={errors.telephone}
            showError={showErrors.telephone}
            country={values?.countryCode || 'MG'}
            onChangeCountry={(newCountry: string) =>
              handleChange('countryCode', newCountry, true)
            }
          />
          <InputField
            label={TitleLabels.contractant.email}
            required
            name="email"
            value={values.email}
            onChange={handleChange}
            error={errors.email}
            showError={showErrors.email}
          />
          <InputDatePicker
            label={TitleLabels.contractant.dateNaissance}
            required
            value={values.dateNaissance}
            name="dateNaissance"
            onChange={handleChange}
            error={errors.dateNaissance}
            showError={showErrors.dateNaissance}
            noInit
            dateMax={new Date()}
          />
          <InputImage
            label={TitleLabels.contractant.cin}
            name="cin"
            value={values.cin}
            onChange={handleChange}
            error={errors.cin}
            showError={showErrors.cin}
            maxLength={2}
            required
          />

          <InputField
            label={TitleLabels.contractant.ville}
            required
            name="ville"
            value={values.ville}
            onChange={handleChange}
            error={errors.ville}
            showError={showErrors.ville}
            maxLength={24}
          />
          <InputField
            label={TitleLabels.contractant.adresse}
            required
            name="adresse"
            value={values.adresse}
            onChange={handleChange}
            error={errors.adresse}
            showError={showErrors.adresse}
            maxLength={50}
          />
          <InputField
            label={TitleLabels.contractant.password}
            required
            type="password"
            name="password"
            value={values.password}
            onChange={handleChange}
            error={errors.password}
            showError={showErrors.password}
          />
          <InputField
            label={TitleLabels.contractant.passwordConfirmation}
            required
            type="password"
            name="passwordConfirmation"
            value={values.passwordConfirmation}
            onChange={handleChange}
            error={errors.passwordConfirmation}
            showError={showErrors.passwordConfirmation}
          />
          <CheckBoxWithHyperlink
            checked={isSelected}
            setChecked={setSelected}
          />
        </View>
        {/** Submit buttons */}
        <View>
          <SecondaryButton
            cancelAction={handleCancel}
            submitAction={!isSelected ? privacyIsChecked : handleSubmit}
            cancelTitle="Annuler"
            submitTitle="S'inscrire"
          />
        </View>
        <Footer connectAction={connectAction} isInscription={true} />
      </View>
    </View>
  );
};
